






























import { defineComponent } from '@nuxtjs/composition-api';
import BaseColor from '@shared/components/@atoms/BaseColor/BaseColor.vue';

import BaseCheckbox from '../BaseCheckbox/BaseCheckbox.vue';
export default defineComponent({
  name: 'BaseFilter',
  components: {
    BaseCheckbox,
    BaseColor,
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    count: {
      type: [String, Number],
      default: '',
    },
    selected: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '',
    },
  },
});
